import { useReducer, useCallback } from "react";
const isDebugging = false;

// Reducer that handles dynamically named entity collections
const entityStateReducer = (state, action) => {
    switch (action.type) {
        case "update":
            // Update in the specific entity set (action.entityType)
            return {
                ...state,
                [action.entityType]: state[action.entityType].map((item) =>
                    item.id === action.entity.id ? action.entity : item,
                ),
            };
        case "delete":
            // Delete from the specific entity set (action.entityType)
            return {
                ...state,
                [action.entityType]: state[action.entityType].filter(
                    (item) => item.id !== action.entity.id,
                ),
            };
        case "setState":
            // Set the state for a specific entity set (action.entityType)
            return {
                ...state,
                [action.entityType]: action.state,
            };
        case "add":
            // Add a new entity to the specific entity set (action.entityType)
            return {
                ...state,
                [action.entityType]: [
                    ...(state[action.entityType] || []),
                    action.entity,
                ],
            };
        case "addFirst":
            // Add a new entity at the start of the specific entity set (action.entityType)
            return {
                ...state,
                [action.entityType]: [
                    action.entity,
                    ...(state[action.entityType] || []),
                ],
            };
        default:
            return state;
    }
};

const useEntityState = () => {
    const [state, dispatch] = useReducer(entityStateReducer, {});

    // Actions for updating, deleting, or setting state for any entity set
    const updateEntityState = useCallback(
        (entity, entityType) =>
            dispatch({ type: "update", entity, entityType }),
        [],
    );
    const deleteEntityState = useCallback(
        (entity, entityType) =>
            dispatch({ type: "delete", entity, entityType }),
        [],
    );
    const setEntityState = useCallback(
        (entitiesArray, entityType) =>
            dispatch({ type: "setState", state: entitiesArray, entityType }),
        [],
    );
    const addEntityState = useCallback(
        (entity, entityType) => dispatch({ type: "add", entity, entityType }),
        [],
    );
    const addFirstEntityState = useCallback(
        (entity, entityType) =>
            dispatch({ type: "addFirst", entity, entityType }),
        [],
    );

    // Retrieve the entities for a given entityType
    const getEntities = useCallback(
        (entityType) => {
            const output = state[entityType] || [];
            if (isDebugging)
                console.log(
                    `getEntities: ${entityType} - ${output.length ? output : "[]"}`,
                );
            return output;
        },
        [state],
    );

    return {
        getEntities,
        updateEntityState,
        deleteEntityState,
        setEntityState,
        addEntityState,
        addFirstEntityState,
    };
};

export default useEntityState;
